<template>
  <div>
    <el-dialog
      title="分配服务器"
      :visible="visible"
      width="878px"
      :close-on-click-modal="false"
      @close="handleCancle"
      @closed="reset"
    >
      <el-form v-loading="loading" ref="serveForm" :model="serveData" :rules="serveFormRules">
        <el-row v-for="(item, index) in serveData" :key="index" class="serve-item">
          <el-row type="flex" align="middle">
            <el-col :span="2">
              <el-switch
                v-if="!item.id"
                :active-value="0"
                :inactive-value="1"
                active-color="#67c33a"
                inactive-color="#f56c6c"
                v-model="item.status"
                :disabled="isDisabled"
              ></el-switch>
              <el-switch
                v-else
                active-color="#67c33a"
                inactive-color="#f56c6c"
                :value="statusType[item.status] ? statusType[item.status].type : false"
                :disabled="isDisabled"
                @change="serveStatusChange(item, index)"
              ></el-switch>
            </el-col>
            <el-col>
              <el-form-item
                label="服务器IP"
                :prop="`${index}.serverId`"
                :rules="serveFormRules.serverId"
              >
                <el-select v-if="!item.id" v-model="item.serverId">
                  <el-option
                    v-for="serverItem in serverIpList"
                    :key="serverItem.serverId"
                    :label="serverItem.serverIp"
                    :value="serverItem.serverId"
                  >
                    <div>
                      {{ serverItem.serverIp }}
                      {{
                        findServer(serverItem.serverId) ? findServer(serverItem.serverId).name : ''
                      }}
                    </div>
                  </el-option>
                </el-select>
                <span v-if="item.id" style="display: inline-block; width: 200px">{{
                  item.serverIp
                }}</span>
                <span v-if="item.serverId">
                  {{ findServer(item.serverId) ? findServer(item.serverId).name : '' }}
                </span>
              </el-form-item>
            </el-col>
          </el-row>
          <el-divider></el-divider>
          <el-row>
            <el-col :span="24" class="all-down">
              <el-col class="all-down-item"
                ><el-switch
                  v-if="!item.id"
                  :disabled="item.status === 1 || isDisabled"
                  :active-value="0"
                  :inactive-value="1"
                  v-model="item.totalPortIssued"
                  active-color="#67c33a"
                  inactive-color="#f56c6c"
                ></el-switch>
                <el-switch
                  v-else
                  :disabled="item.status === 1 || isDisabled"
                  :value="
                    statusType[item.totalPortIssued] ? statusType[item.totalPortIssued].type : false
                  "
                  @change="portsStatusChange(item, index)"
                  active-color="#67c33a"
                  inactive-color="#f56c6c"
                ></el-switch>
                <span> 总端口下发 </span>
              </el-col>
            </el-col>
            <el-col :span="24">
              <el-table :data="item.protocolVersionServerPortParamList" border>
                <el-table-column
                  align="center"
                  type="index"
                  width="60"
                  label="序号"
                ></el-table-column>
                <el-table-column align="center" label="服务器端口号" prop="serverPort">
                  <template slot-scope="{ row, $index }">
                    <el-form-item
                      :prop="`${index}.protocolVersionServerPortParamList.${$index}.serverPort`"
                      :rules="portRules.serverPort"
                    >
                      <el-input-number
                        :controls="false"
                        v-if="!row.id"
                        placeholder="请输入"
                        v-model.trim="item.protocolVersionServerPortParamList[$index].serverPort"
                      ></el-input-number>
                      <span v-else>{{ row.serverPort }}</span>
                    </el-form-item>
                  </template>
                </el-table-column>
                <el-table-column align="center" label="负载量" prop="serverLoad">
                  <template slot-scope="{ row, $index }">
                    <el-form-item
                      :prop="`${index}.protocolVersionServerPortParamList.${$index}.serverLoad`"
                      :rules="portRules.serverLoad"
                    >
                      <el-input-number
                        v-if="!isDisabled"
                        placeholder="请输入"
                        :controls="false"
                        v-model.trim="item.protocolVersionServerPortParamList[$index].serverLoad"
                        @focus="getLoad(row)"
                        @blur="setLoad(row)"
                      ></el-input-number>
                      <span v-else>{{ row.serverLoad }}</span>
                    </el-form-item>
                  </template>
                </el-table-column>
                <el-table-column align="center" label="负载状态" prop="serverLoadStatus">
                  <template slot-scope="{ row }">
                    <span
                      :class="
                        loadTypeList[row.serverLoadStatus]
                          ? loadTypeList[row.serverLoadStatus].class
                          : ''
                      "
                      >{{
                        loadTypeList[row.serverLoadStatus]
                          ? loadTypeList[row.serverLoadStatus].type
                          : ''
                      }}</span
                    >
                  </template>
                </el-table-column>
                <el-table-column align="center" label="是否下发" prop="portIssued">
                  <template slot-scope="{ row, $index }">
                    <el-switch
                      v-if="!row.id"
                      :disabled="item.status === 1 || item.totalPortIssued === 1 || isDisabled"
                      :active-value="0"
                      :inactive-value="1"
                      v-model="item.protocolVersionServerPortParamList[$index].portIssued"
                      active-color="#67c33a"
                      inactive-color="#f56c6c"
                    ></el-switch>
                    <el-switch
                      v-else
                      :disabled="item.status === 1 || item.totalPortIssued === 1 || isDisabled"
                      :value="statusType[row.portIssued] ? statusType[row.portIssued].type : false"
                      @change="portStatusChange(row)"
                      active-color="#67c33a"
                      inactive-color="#f56c6c"
                    ></el-switch>
                  </template>
                </el-table-column>
              </el-table>
            </el-col>
            <el-col :span="24" v-if="item.status === 0 && item.totalPortIssued === 0 && !item.id">
              <el-button type="text" @click="addPort(index)">增加行</el-button>
            </el-col>
          </el-row>
          <el-divider v-if="index != serveArrData.length - 1"></el-divider>
        </el-row>
      </el-form>
      <el-button v-if="!isDisabled" style="margin-top: 12px" type="primary" @click="addServe"
        >增加服务器</el-button
      >
      <el-row slot="footer" type="flex" justify="end">
        <el-button
          v-if="isNew && !isDisabled"
          type="primary"
          :loading="btnLoading"
          @click="handleAddServe"
          style="margin-right: 8px"
          >保存</el-button
        >
        <el-button @click="handleCancle">取消</el-button>
      </el-row>
    </el-dialog>
    <ValidatPass ref="validatPass" @back="validateBack" />
  </div>
</template>
<script>
import { cloneDeep, uniq } from 'lodash';
import validatePassApi from 'api/home/validatePass';
import dealApi from 'api/home/deal-mangement';
import ValidatPass from '@/components/PermissionPassword/ValidatPass';
import statusType from '@/config/status';
export default {
  components: {
    ValidatPass
  },
  data() {
    return {
      statusType,
      // 是否新增判断保存按钮展示
      isNew: false,
      loadTypeList: {
        0: { type: '空闲', class: 'blue-col' },
        1: { type: '正常', class: 'green-col' },
        2: { type: '拥挤', class: 'yellow-col' },
        3: { type: '满载', class: 'red-col' }
      },
      isDisabled: false,
      nowServerId: '',
      serverIpList: [],
      serveDataTem: {
        serverId: '',
        totalPortIssued: 0,
        status: 0,
        protocolVersionServerPortParamList: [
          {
            serverPort: undefined,
            serverLoad: undefined,
            serverLoadStatus: '',
            portIssued: 0
          }
        ]
      },
      portTem: {
        serverPort: undefined,
        serverLoad: undefined,
        serverLoadStatus: '',
        portIssued: 0
      },
      serveArrData: [],
      versionId: '',
      versionName: '',
      serveFormRules: {
        serverId: [{ required: true, message: '必选项', trigger: 'change' }]
      },
      portRules: {
        serverPort: [{ validator: this.validatNumber, trigger: 'blur' }],
        serverLoad: [{ validator: this.validatLoadNumber, trigger: 'blur' }]
      },
      oldLoad: {},
      btnLoading: false,
      loading: false,
      visible: false,
      needChangeStatusData: {}
    };
  },
  computed: {
    // 数据数组->对象
    serveData() {
      let obj = {};
      for (const key in this.serveArrData) {
        obj[key] = this.serveArrData[key];
      }
      return obj;
    },
    ipPortData() {
      let obj = {};
      const serveArrData = this.serveArrData.filter(item => {
        return item.serverId;
      });
      for (const key in serveArrData) {
        obj[serveArrData[key].serverId] = [
          ...(obj[serveArrData[key].serverId] || []),
          ...serveArrData[key].protocolVersionServerPortParamList.map(item => {
            return item.serverPort;
          })
        ];
      }
      return obj;
    }
  },
  methods: {
    // 表单验证
    validatNumber(rule, value, callback) {
      const test = /^[+]{0,1}(\d+)$/;
      if (!test.test(value)) {
        callback(new Error('请输入正整数'));
        return;
      }
      if (value < 1 || value > 65535) {
        callback(new Error('请输入1-65535间的数'));
        return;
      }
      let flag = false;
      for (const key in this.ipPortData) {
        let length = this.ipPortData[key].length;
        let newLength = uniq(this.ipPortData[key]).length;
        flag = length !== newLength;
      }
      if (flag) {
        callback(new Error('同服务器端口号不允许重复'));
      }
      callback();
    },
    validatLoadNumber(rule, value, callback) {
      const test = /^[+]{0,1}(\d+)$/;
      if (!test.test(value)) {
        callback(new Error('请输入正整数'));
        return;
      }
      if (value < 1 || value > 1000000) {
        callback(new Error('请输入1-1000000间的数'));
        return;
      }
      callback();
    },
    // 数据初始化
    init(data) {
      this.visible = true;
      this.versionId = data.versionId;
      this.versionName = data.protocolVersion;
      this.isDisabled = !!data.isDisabled;
      this.getServeList();
      this.getServeDetail();
    },
    // 第一次分配增加初始服务器
    initForm() {
      this.serveArrData = [cloneDeep(this.serveDataTem)];
      this.isNew = true;
    },
    // 关闭模态框
    handleCancle() {
      !this.loading && !this.btnLoading && (this.visible = false);
    },
    // 数据重置
    reset() {
      this.$refs.serveForm.resetFields();
      this.versionId = '';
      this.versionName = '';
      this.isNew = false;
      this.loading = false;
      this.btnLoading = false;
      this.isDisabled = false;
      this.serverIpList = [];
      this.serveArrData = [];
      this.oldLoad = [];
    },
    // 获得历史负载量
    getLoad(row) {
      row.id && row.serverLoad && (this.oldLoad[row.id] = row.serverLoad);
    },
    // 设置新负载量
    setLoad(row) {
      if (this.btnLoading) {
        return;
      }
      if (this.oldLoad[row.id] == row.serverLoad) {
        return;
      }
      row.id && this.loadChange(row);
    },
    // 负载量改变接口
    loadChange(loadData) {
      const { id, serverLoad } = loadData;
      if (!serverLoad) {
        return;
      }
      if (serverLoad < 1 || serverLoad > 1000000) {
        return;
      }
      this.loading = true;
      dealApi
        .changeLoad({ id, serverLoad })
        .then(res => {
          const {
            data: { data, code }
          } = res;
          if (code !== 200) {
            loadData.serverLoad = this.oldLoad[id];
            return;
          }
          this.overLoadServerDetail();
        })
        .catch(() => {
          loadData.serverLoad = this.oldLoad[id];
        })
        .finally(() => {
          this.$nextTick(() => {
            this.loading = false;
          });
        });
    },
    getServeList() {
      dealApi.getServerList().then(res => {
        const {
          data: { data, code }
        } = res;
        if (code !== 200) {
          return;
        }
        this.serverIpList = data.map(item => {
          return {
            serverId: item.id,
            serverIp: item.localAreaIp,
            name: item.deviceName
          };
        });
      });
    },
    // 获取服务器分配详情
    getServeDetail() {
      this.loading = true;
      dealApi
        .getServerDetail({ protocolVersionId: this.versionId })
        // .getServerDetail({ protocolVersionId: '1539538261106270211' })
        .then(res => {
          const {
            data: { data, code }
          } = res;
          if (code !== 200) {
            return;
          }
          this.$nextTick(() => {
            this.serveArrData = data.map(item => {
              return {
                id: item.id,
                protocolVersionId: item.protocolVersionId,
                serverIp: item.serverIp,
                serverId: item.serverId,
                totalPortIssued: item.totalPortIssued,
                status: item.status,
                protocolVersionServerPortParamList:
                  item.protocolVersionServerPortResultList.length === 0
                    ? [cloneDeep(this.portTem)]
                    : item.protocolVersionServerPortResultList
              };
            });
            this.serveArrData.length === 0 && this.initForm();
          });
        })
        .finally(() => {
          this.loading = false;
        });
    },
    // 状态变化/端口负载变化 重载列表
    overLoadServerDetail() {
      this.loading = true;
      dealApi
        .getServerDetail({ protocolVersionId: this.versionId })
        // .getServerDetail({ protocolVersionId: '1539538261106270211' })
        .then(res => {
          const {
            data: { data, code }
          } = res;
          if (code !== 200) {
            return;
          }
          this.$nextTick(() => {
            const newArrData = data.map(item => {
              return {
                id: item.id,
                protocolVersionId: item.protocolVersionId,
                serverIp: item.serverIp,
                serverId: item.serverId,
                totalPortIssued: item.totalPortIssued,
                status: item.status,
                protocolVersionServerPortParamList: item.protocolVersionServerPortResultList
              };
            });
            this.serveArrData = [...newArrData, ...this.serveArrData.filter(item => !item.id)];
          });
        })
        .finally(() => {
          this.$nextTick(() => {
            this.loading = false;
            this.oldLoad = {};
          });
        });
    },
    // overLoadServeFun() {},
    // getStatusChangeServerDetail(data, type) {
    //   if (type == 1) {
    //     let index = this.serveArrData.find(item => {
    //       return item.id == data.id;
    //     });
    //     let obj = {
    //       ...data
    //     };
    //     obj.status = obj.status === 1 ? 0 : 1;
    //     this.serveArrData.splice(index, 1, { ...obj });
    //   }
    // },

    // 增加服务器
    addServe() {
      this.serveArrData.push(cloneDeep(this.serveDataTem));
      this.isNew = true;
    },
    // 服务器增加端口
    addPort(index) {
      this.serveArrData[index].protocolVersionServerPortParamList.push(cloneDeep(this.portTem));
      this.isNew = true;
    },
    // 保存
    handleAddServe() {
      this.$refs.serveForm.validate(validated => {
        if (!validated) {
          return;
        }
        this.btnLoading = true;
        let data = this.serveArrData.filter(item => {
          return !item.id;
        });
        data = data.map(item => {
          return {
            ...item,
            serverIp: this.findServer(item.serverId).serverIp,
            serverName: this.findServer(item.serverId).name,
            protocolVersionId: this.versionId,
            protocolVersionName: this.versionName
          };
        });
        data.forEach(item => {
          item.protocolVersionServerPortParamList = item.protocolVersionServerPortParamList.map(
            portItem => {
              return {
                portIssued: portItem.portIssued,
                serverLoad: portItem.serverLoad,
                serverPort: portItem.serverPort
              };
            }
          );
        });
        dealApi
          .addOrEditServer(data)
          .then(res => {
            const {
              data: { code }
            } = res;
            if (code !== 200) {
              return;
            }
            this.$message.success('服务器分配成功');
            this.$emit('back', true, false);
            this.visible = false;
          })
          .finally(() => {
            this.btnLoading = false;
          });
      });
    },
    // 根据id获得所选服务器详情
    findServer(id) {
      return this.serverIpList.find(item => item.serverId == id);
    },
    // 状态改变
    // 服务器
    serveStatusChange(data) {
      if (this.btnLoading) {
        return;
      }
      const { id, status } = data;
      if (status == 1) {
        validatePassApi.editServerStatus({ status: 0, id: id }, '').then(res => {
          if (res.data.code === 200) {
            this.overLoadServerDetail();
          }
        });
      } else {
        this.$refs.validatPass.init({ status: 1, id: id }, 3, true);
        this.needChangeStatusData = data;
      }
    },
    // 端口
    portStatusChange(data) {
      if (this.btnLoading) {
        return;
      }
      const { id, portIssued } = data;
      if (portIssued == 1) {
        validatePassApi.editSortStatus({ portIssued: 0, id: id }, '').then(res => {
          if (res.data.code === 200) {
            // this.getDealList();
            this.overLoadServerDetail();
          }
        });
      } else {
        this.$refs.validatPass.init({ portIssued: 1, id: id }, 4, true);
        this.needChangeStatusData = data;
      }
    },
    // 总端口
    portsStatusChange(data) {
      if (this.btnLoading) {
        return;
      }
      const { id, totalPortIssued } = data;
      if (totalPortIssued == 1) {
        validatePassApi.editSortsStatus({ totalPortIssued: 0, id: id }, '').then(res => {
          if (res.data.code === 200) {
            this.overLoadServerDetail();
          }
        });
      } else {
        this.$refs.validatPass.init({ totalPortIssued: 1, id: id }, 5, true);
        this.needChangeStatusData = data;
      }
    },
    // 验证返回
    validateBack(flag, index) {
      this.overLoadServerDetail();
    }
  }
};
</script>
<style lang="less" scoped>
.serve-item {
  margin-bottom: 12px;
}
/deep/ .el-input__inner {
  border: none;
  background-color: transparent;
}
/deep/ .el-form-item {
  margin: 0;
}
/deep/ .el-table__body .cell {
  .el-form-item__error {
    margin: 4px 0 0 0;
    padding: 0;
    position: static;
    white-space: normal;
  }

  textarea {
    border: none;
    background-color: transparent;
    resize: none;
  }
}
.all-down {
  display: flex;
  align-items: center;
  .all-down-item {
    margin-bottom: 12px;
    span {
      margin-left: 16px;
    }
  }
}
.btn {
  display: flex;
  width: 24px;
  height: 24px;
  justify-content: center;
  align-items: center;
  cursor: pointer;
  font-size: 20px;
  background-color: black;
  color: white;
  border-radius: 50%;
}
</style>